import React, { EffectCallback, ReactElement, useEffect } from 'react';
import { NavigateFunction, Params, useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Dispatch } from 'redux';

import { RootState } from '../../../../types/state/root.types';
import { SupportState } from '../../../../types/state/support.types';

import { setMessages } from '../../../../slices/programme/support/support.slice';

import { requestViewMessages, requestCreateMessage } from '../../../../api/support/support.actions';

import SupportChat from '../../../../components/screens/programme/support/support-chat/SupportChat';

const SupportChatContainer = (): ReactElement => {
  const { messageOwner, messages } = useSelector(({ support }: RootState): SupportState => support);

  const dispatch: Dispatch = useDispatch();

  const navigate: NavigateFunction = useNavigate();

  const { status, systemUserExternalReference, programmeExternalReference }: Params = useParams();

  useEffect((): ReturnType<EffectCallback> => {
    dispatch(
      // @ts-expect-error TODO: Fix after adding types to support actions
      requestViewMessages({
        programmeExternalReference,
        systemUserExternalReference,
        page: 0,
        size: 99,
        showSpinner: true
      })
    );

    const interval: NodeJS.Timeout = setInterval((): void => {
      dispatch(
        // @ts-expect-error TODO: Fix after adding types to support actions
        requestViewMessages({
          programmeExternalReference,
          systemUserExternalReference,
          page: 0,
          size: 99
        })
      );
    }, 5000);

    return (): void => clearInterval(interval);
  }, [dispatch, programmeExternalReference, systemUserExternalReference]);

  const createMessage = (text: string, onSuccess: () => void): void => {
    dispatch(
      // @ts-expect-error TODO: Fix after adding types to support actions
      requestCreateMessage({
        input: {
          text,
          programmeExternalReference,
          systemUserExternalReference
        },
        onSuccess: (): void => {
          // @ts-expect-error TODO: Fix after adding types to support actions
          dispatch(requestViewMessages({ programmeExternalReference, systemUserExternalReference, page: 0, size: 99 }));
          onSuccess();
        }
      })
    );
  };

  const navigateBack = (): void => {
    navigate(`/programmes/${status}/${programmeExternalReference}/support`);
    dispatch(setMessages([]));
  };

  return (
    <SupportChat
      status={status as string}
      messageOwner={messageOwner}
      messages={messages}
      createMessage={createMessage}
      navigateBack={navigateBack}
    />
  );
};

export default SupportChatContainer;
